import { conformToMask } from 'react-text-mask';
import {
  LOCALE_PT_JP,
  LOCALE_PT_US,
  LOCALE_PT_UK,
  LOCALE_PT_PT,
  LOCALE_PT_AO,
  LOCALE_PT_BR,
  LOCALE_PT_IE,
  LOCALE_PT_BO,
  LOCALE_PT_IT,
} from 'commons/locale/localeConstants';

const LOCALE_SETTINGS = {
  [LOCALE_PT_JP]: {
    moneyDetails: {
      precision: 0,
      separator: '.',
      delimiter: ',',
      unit: '¥',
      suffixUnit: '',
    },
    phoneMask: [/\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/],
  },
  [LOCALE_PT_US]: {
    moneyDetails: {
      precision: 2,
      separator: '.',
      delimiter: ',',
      unit: '$',
      suffixUnit: '',
    },
    phoneMask: [/\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/],
  },
  [LOCALE_PT_UK]: {
    moneyDetails: {
      precision: 2,
      separator: '.',
      delimiter: ',',
      unit: '£',
      suffixUnit: '',
    },
    phoneMask: [/\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/],
  },
  [LOCALE_PT_PT]: {
    moneyDetails: {
      precision: 2,
      separator: ',',
      delimiter: '.',
      unit: '€',
      suffixUnit: '',
    },
    phoneMask: [/\d/, /\d/, /\d/, ' ', /\d/, /\d/, /\d/, ' ', /\d/, /\d/, /\d/],
  },
  [LOCALE_PT_AO]: {
    moneyDetails: {
      precision: 0,
      separator: ',',
      delimiter: '.',
      unit: 'Kz',
      suffixUnit: '',
    },
    phoneMask: [/\d/, /\d/, /\d/, ' ', /\d/, /\d/, /\d/, ' ', /\d/, /\d/, /\d/],
  },
  [LOCALE_PT_IE]: {
    moneyDetails: {
      precision: 2,
      separator: ',',
      delimiter: '.',
      unit: '€',
      suffixUnit: '',
    },
    phoneMask: [/\d/, /\d/, ' ', /\d/, /\d/, /\d/, ' ', /\d/, /\d/, /\d/, /\d/],
  },
  [LOCALE_PT_BO]: {
    moneyDetails: {
      precision: 2,
      separator: ',',
      delimiter: '.',
      unit: 'Bs',
      suffixUnit: '',
    },
    phoneMask: [/\d/, /\d/, /\d/, /\d/, ' ', /\d/, /\d/, /\d/, /\d/],
  },
  [LOCALE_PT_IT]: {
    moneyDetails: {
      precision: 2,
      separator: ',',
      delimiter: '.',
      unit: '€',
      suffixUnit: '',
    },
    phoneMask: [/\d/, /\d/, /\d/, ' ', /\d/, /\d/, /\d/, ' ', /\d/, /\d/, /\d/, /\d/],
  },
  [LOCALE_PT_BR]: {
    moneyDetails: {
      precision: 2,
      separator: ',',
      delimiter: '.',
      unit: 'R$',
      suffixUnit: '',
    },
    phoneMask: ['(', /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/],
  },
};

export function getMaskSettingsByLocale(locale) {
  if (!locale) {
    return LOCALE_SETTINGS[LOCALE_PT_BR];
  }
  return LOCALE_SETTINGS[locale] ?? LOCALE_SETTINGS[LOCALE_PT_BR];
}

let selectedMaskSettings = getMaskSettingsByLocale();

const MaskUtils = {
  phone(value) {
    if (!value) {
      return '';
    }
    return conformToMask(value, selectedMaskSettings.phoneMask, {
      guide: false,
    }).conformedValue;
  },

  cpf(value) {
    if (!value) {
      return value;
    }
    return value
      .replace(/\D/g, '')
      .replace(/(\d{3})(\d)/, '$1.$2')
      .replace(/(\d{3})(\d)/, '$1.$2')
      .replace(/(\d{3})(\d{1,2})/, '$1-$2')
      .replace(/(-\d{2})\d+?$/, '$1');
  },

  setLocale(localeString) {
    selectedMaskSettings = getMaskSettingsByLocale(localeString);
  },
  getMoneyMaskSettings() {
    return selectedMaskSettings.moneyDetails;
  },
  getPhoneMask() {
    return selectedMaskSettings.phoneMask;
  },
};

export { MaskUtils as default };
